import platform from "../../util/platform";
const create = (request) => {
    const path = `/session/create`;
    return (params) => {
        return platform.post(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const createFromAccessCode = (accessCode) => {
    const path = `/session/create/access-code/${accessCode}`;
    return (params) => {
        return platform.post(params, platform.getEdgeBaseUrl(), path, {});
    };
};
const session = {
    create,
    createFromAccessCode
};
export default session;
